import { useHasActiveSKU } from '@/shared/auth/hooks/use-has-valid-sku'
import { useCurrentRole } from '@/shared/auth/store'

import { roleHasCollectorPermission } from '../permissions'

import type { CollectorPermission } from '../permissions'

/**
 * Whether the active role carries `permission` on an active SKU. The SKU
 * condition is unchanged from the rank gate it replaces — a separate
 * requirement from the role, not folded into the permission set.
 */
export const useCollectorPermission = (
	permission: CollectorPermission,
): boolean => {
	const role = useCurrentRole()
	const hasActiveSKU = useHasActiveSKU()

	return roleHasCollectorPermission(role, permission) && hasActiveSKU
}
